import React, { createContext, useContext, useState } from 'react';
import SessionExpiredToast from '../components/SessionExpiredToast';

const ToastContext = createContext();

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider = ({ children }) => {
    const [sessionExpired, setSessionExpired] = useState(false);
    const [logoutCallback, setLogoutCallback] = useState(null);

    const showSessionExpired = (onLogout) => {
        setSessionExpired(true);
        setLogoutCallback(() => onLogout); // Store callback function
    };

    const hideSessionExpired = () => {
        setSessionExpired(false);
        setLogoutCallback(null);
    };

    const handleLoginAgain = () => {
        hideSessionExpired();
        if (logoutCallback) {
            logoutCallback();
        }
    };

    return (
        <ToastContext.Provider value={{ showSessionExpired, hideSessionExpired }}>
            {children}
            <SessionExpiredToast
                open={sessionExpired}
                onLoginAgain={handleLoginAgain}
            />
        </ToastContext.Provider>
    );
};